module.exports = __webpack_public_path__ + "static/Q8Answer2_Callmemaybe_eliska_motisova-4ed7f3a79fc7d0734bd3b98fac8cecdf.jpg";